import { render, staticRenderFns } from "./ElOrders.vue?vue&type=template&id=f9f5cd12&scoped=true&"
import script from "./ElOrders.vue?vue&type=script&lang=js&"
export * from "./ElOrders.vue?vue&type=script&lang=js&"
import style0 from "./ElOrders.vue?vue&type=style&index=0&id=f9f5cd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f5cd12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f5cd12')) {
      api.createRecord('f9f5cd12', component.options)
    } else {
      api.reload('f9f5cd12', component.options)
    }
    module.hot.accept("./ElOrders.vue?vue&type=template&id=f9f5cd12&scoped=true&", function () {
      api.rerender('f9f5cd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElOrders.vue"
export default component.exports